import React, { useState } from "react";
import Offers from "./offers/Offers";
import DestinationContent from "./destination/DestinationContent";

const ContentManagement: React.FC = () => {
  const [activeSection, setActiveSection] = useState<string>("offers");

  const handleButtonClick = (section: string) => {
    setActiveSection(section);
  };

  return (
    <div className="container mx-auto p-4">
      <h1 className="text-3xl font-bold mb-4">Content Management</h1>
      <div className="bg-white p-4 shadow-md rounded-lg overflow-hidden ">
        <div className="flex gap-8 pt-4 pb-2">
          <button
            onClick={() => handleButtonClick("offers")}
            className={`border-b-2 ${
              activeSection === "offers"
                ? "border-blue-500 text-black font-bold"
                : "border-transparent font-normal"
            }`}
          >
            Manage Offers
          </button>

          <button
            onClick={() => handleButtonClick("destination")}
            className={` border-b-2 ${
              activeSection === "destination"
                ? "border-blue-500 text-black font-bold"
                : "border-transparent font-normal"
            }`}
          >
            Manage Destination
          </button>
        </div>

        <div>
          {activeSection === "offers" && (
            <div className="content-box">
              <Offers />
            </div>
          )}
          {activeSection === "destination" && (
            <div className="content-box">
              <DestinationContent />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContentManagement;
